import React, {useState, useEffect, useCallback} from 'react';
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Col, Form } from "react-bootstrap";
import Select from "react-select";
import useAPI from '../../../hooks/useAPI';
import useToast from '../../../hooks/useToast';
import Required from '../../../components/Required';
import BackBtn from '../../../components/UI/BackBtn';

const getUserLabel = (user) => {
  return `${user.lastName} ${user.firstName} ${user.middleName}, ${user.post}`;
};

const NioktrEditReceipt = () => {
	const api = useAPI();
	const addToast = useToast();
	const history = useHistory();
	const { stratId, receiptId } = useParams();
	const year = localStorage.getItem('year');
	const actualStrategyId = localStorage.getItem('strategyId');
	const topicHead = {value: '', label: localStorage.getItem('topicHead')};
	const institute = {value: '', label: localStorage.getItem('headInstitute')};
	const topic = localStorage.getItem('topic');
	const headAccName = localStorage.getItem('headAccName');

	const [teamMembers, setTeamMembers] = useState([]);
	const [institutes, setInstitutes] = useState([]);
	const [selectedHead, setSelectedHead] = useState(topicHead);
	const [selectedInstitute, setSelectedInstitute] = useState(institute);
	const [selectedProject, setSelectedProject] = useState({});
	const [topicName, setTopicName] = useState(topic);
	const [searchHeadValue, setSearchHeadValue] = useState('');
	const [projectsOptions, setProjectsOptions] = useState([]);

	const removeStorage = () => {
		localStorage.removeItem("topic");
		localStorage.removeItem("topicHead");
		localStorage.removeItem("headInstitute");
		localStorage.removeItem('headAccName');
		localStorage.removeItem('policyId');
    localStorage.removeItem('strategyId');
    localStorage.removeItem('year');
	};

	const handleSubmit = async () => {
		const policyOrProj = selectedProject.policyId ? {
			policyId: selectedProject.policyId,
		} : {
			strategyId: selectedProject.strategyId,
		};

		const result = await api.post(`/factdata/contracts/0/pa/${receiptId}`, {
			contractPAId: receiptId,
			policyId: stratId,
			year: year,
      topic: topicName,
      personsInCharge: [{
        institute: selectedInstitute.label || institute.label,
        sAMAccountName: selectedHead.value.sAMAccountName || headAccName,
      }],
			...policyOrProj,
		});

		if (!result.hasOwnProperty('error')) {
			addToast.success('Поступление отредактировано');
			history.push(`/policies/${stratId}/budget?t=nioktrReceipts`);
			removeStorage();
		}
	};

	const getData = useCallback(async () => {
		if (searchHeadValue) {
			const resp = await api.get(`/users?name=${searchHeadValue}`)
			setTeamMembers(resp?.map((value) => ({
				label: getUserLabel(value),
				value,
			})));
		}
		const activeProjects = await api.get('/mng/strategies?active=true');
		setProjectsOptions(activeProjects.map((strategy) => ({label: strategy.name, value: strategy.id})));

		const institutes = await api.get('/structure/institutes');
		setInstitutes(institutes.map((e) => ({
			label: e.title,
			value: e.id,
		})))
	}, [searchHeadValue]);

	useEffect(() => {
		getData()
	}, [searchHeadValue]);
	
	return (
		<section className="page project-page">
			<div className="container">
				<BackBtn />
				<h3 style={{color: 'black', margin: '20px 0 36px', textAlign: 'start'}}>Редактирование карточки поступления</h3>
				<div>
					<Card style={{marginBottom: '20px'}}>
						<Card.Body style={{padding: '30px 25px', display: 'flex', flexDirection: 'column', rowGap: '24px'}}>
							<Form.Group as={Col}>
								<Form.Label style={{color: '#7F7F7F'}}>Наименование темы <Required/></Form.Label>
								<Form.Control
									as={'input'}
									required
									name={'topic'}
									value={topicName}
									onChange={({ target }) => setTopicName(target.value)}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<Form.Label style={{color: '#7F7F7F'}}>Руководитель темы <Required/></Form.Label>
								<Select
									placeholder="Введите ФИО и выберите из списка"
									options={teamMembers}
									value={selectedHead}
									onChange={setSelectedHead}
									onInputChange={setSearchHeadValue}
									noOptionsMessage={() => 'Список пуст'}
									required={true}
									isClearable={true}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<Form.Label style={{color: '#7F7F7F'}}>Институт (где работает руководитель темы) <Required/></Form.Label>
								<Select
									placeholder="Выберите институт из списка"
									options={institutes}
									value={selectedInstitute}
									onChange={setSelectedInstitute}
									noOptionsMessage={() => 'Список пуст'}
									required={true}
									isSearchable={false}
									isClearable={true}
								/>
							</Form.Group>

							<Form.Group as={Col}>
								<Form.Label style={{color: '#7F7F7F'}}>Стратегический проект или раздел научно-исследовательской политики Программы развития университета, в рамках реализации которого (ых) поступили денежные средства</Form.Label>
								<Select
									value={projectsOptions.find((opt) => opt.value == actualStrategyId)}
									options={projectsOptions}
									noOptionsMessage={() => 'Список пуст'}
									isSearchable={false}
									isDisabled={true}
								/>
							</Form.Group>
						</Card.Body>
					</Card>

					<Card>
						<Card.Body style={{display: 'flex', columnGap: '8px', padding: '30px 25px' }}>
							<Button
								onClick={() => {
									new Promise(resolve => {
										resolve(history.goBack())
									})
									.then(() => {
										removeStorage();
									})
								}}
								type={'button'}
								variant={'outline-secondary'}
							>
								Отменить
							</Button>
							<Button onClick={handleSubmit}>Сохранить</Button>
						</Card.Body>
					</Card>
				</div>
			</div>
		</section>
	);
};

export default NioktrEditReceipt;
